module.exports = __webpack_public_path__ + "static/media/gilroy-extrabold-webfont.33f9f220.woff2";